export const dailyStatsColorDefaults = {
  dailyStatsCustomColors: false,
  dailyStatsBaseColor: '#A62126',
  dailyStatsRecordColor: '#f7c315',
  dailyStatsRange1From: 5000,
  dailyStatsRange1To: 10000,
  dailyStatsRange1Color: '#47a621',
  dailyStatsRange2From: 10000,
  dailyStatsRange2To: 15000,
  dailyStatsRange2Color: '#ffea7e',
  dailyStatsRange3From: 20000,
  dailyStatsRange3To: 0,
  dailyStatsRange3Color: '#000000'
};

export const dailyStatsRangeFields = [1, 2, 3].map((number) => ({
  fromKey: `dailyStatsRange${number}From`,
  toKey: `dailyStatsRange${number}To`,
  colorKey: `dailyStatsRange${number}Color`
}));

export function validateDailyStatsColors(settings) {
  const errors = {};
  if (!settings.dailyStatsCustomColors) return errors;
  const ranges = dailyStatsRangeFields.map(({ fromKey, toKey }) => {
    const from = Number(settings[fromKey]);
    const to = Number(settings[toKey]);
    if (settings[fromKey] == null || settings[fromKey] === '' || !Number.isFinite(from) || from < 0) errors[fromKey] = 'Enter a nonnegative number.';
    if (!Number.isFinite(to) || to < 0) errors[toKey] = 'Enter a nonnegative number or leave empty.';
    else if (to !== 0 && to <= from) errors[toKey] = 'To must be greater than From.';
    return { from, to: to === 0 ? Infinity : to, fromKey };
  });
  ranges.forEach((range, index) => {
    ranges.slice(index + 1).forEach((other) => {
      if (Math.max(range.from, other.from) < Math.min(range.to, other.to)) {
        errors[range.fromKey] = errors[other.fromKey] = 'Ranges must not overlap.';
      }
    });
  });
  return errors;
}

export function normalizeDailyStatsColors(settings) {
  const normalized = { ...settings };
  dailyStatsRangeFields.forEach(({ fromKey, toKey }) => {
    normalized[fromKey] = settings[fromKey] === '' ? dailyStatsColorDefaults[fromKey] : Number(settings[fromKey]);
    normalized[toKey] = Number(settings[toKey]);
  });
  return normalized;
}

export function getDailyStatsColor(meters, settings, isRecord) {
  if (settings?.dailyStatsCustomColors) {
    if (isRecord) return settings.dailyStatsRecordColor;
    const range = dailyStatsRangeFields.find(({ fromKey, toKey }) => meters > settings[fromKey] && (settings[toKey] === 0 || meters <= settings[toKey]));
    return range ? settings[range.colorKey] : settings.dailyStatsBaseColor;
  }
  if (meters > 20000) return '#000000';
  if (meters > 10000 && meters <= 15000) return '#ffea7e';
  if (meters > 5000 && meters <= 10000) return '#47a621';
  return '#A62126';
}
